export const QUANTITY_UNIT_MEASURE = [
  `товар`,
  `товара`,
  `товаров`
];

export const PRICE_CURRENCY = `руб.`;
